import environment from "environment";
import { BaseService } from "@ucchub/ui/src/BaseService";
import { useState } from "react";
import { t } from "i18next";
import toArrayQueryString from "@ucchub/ui/src/utils/queryStringWithArray";
import { NumberTypesListRequestV1 } from "@ucchub/ui/src/apiTypes/cloudNumbers/NumberTypesListRequestV1";
import { ServiceTypeListResponseV1 } from "@ucchub/ui/src/apiTypes/customType/serviceTypeListResponseV1";
import { NumberTypeV1 } from "@ucchub/ui/src/apiTypes/cloudNumbers/numberTypeV1";

export type NumberType = Pick<NumberTypeV1, "id" | "name">;

const useNumberType = () => {
  const [numberTypeList, setNumberTypeList] = useState<NumberType[]>([]);
  const [numberTypeError, setNumberTypeListError] = useState<string>();
  const [isNumberTypeLoading, setIsNumberTypeLoading] = useState(false);

  const fetchNumberTypeList = (payload: NumberTypesListRequestV1) => {
    setIsNumberTypeLoading(true);
    setNumberTypeListError("");
    const queryString = toArrayQueryString(payload);
    const apiUrl = environment.sharedApi.numberType + "?" + queryString;
    BaseService.get<ServiceTypeListResponseV1[]>(apiUrl)
      .then(({ data }) => {
        setNumberTypeList(data);
      })
      .catch(() => {
        setNumberTypeListError(
          t("core:customers:fetch_failure_number_type") || undefined
        );
      })
      .finally(() => {
        setIsNumberTypeLoading(false);
      });
  };
  return {
    numberTypeList,
    numberTypeError,
    isNumberTypeLoading,
    fetchNumberTypeList,
  };
};

export default useNumberType;
